import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { signupRequestsAPI } from '../utils/api';
import './AdminSignupRequests.css';

export default function AdminSignupRequests() {
  const [loading, setLoading] = useState(true);
  const [requests, setRequests] = useState([]);
  const [error, setError] = useState('');
  const [actingId, setActingId] = useState(null);
  const [inviteInfo, setInviteInfo] = useState(null);
  const timerRef = useRef(null);

  const load = async () => {
    try {
      setError('');
      const res = await signupRequestsAPI.listMine();
      setRequests(res?.data?.requests || []);
    } catch (e) {
      setError(e.message || 'Failed to load requests');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    timerRef.current = setInterval(load, 3000);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  const respond = async (id, decision) => {
    setActingId(id);
    setError('');
    setInviteInfo(null);
    try {
      const res = await signupRequestsAPI.respond(id, decision);
      if (decision === 'approved') {
        setInviteInfo(res?.data?.invite || null);
      }
      await load();
    } catch (e) {
      setError(e.message || 'Failed to respond');
    } finally {
      setActingId(null);
    }
  };

  return (
    <div className="sr-shell">
      <div className="sr-page">
      <div className="sr-header">
        <h1>Signup Requests</h1>
        <div className="sr-actions">
          <Link to="/dashboard" style={{ textDecoration: 'none' }}>
            <button type="button">Back</button>
          </Link>
          <button className="primary" type="button" onClick={load}>Refresh</button>
        </div>
      </div>

      {error && <div className="sr-error">{error}</div>}

      {inviteInfo?.signupUrl && (
        <div className="sr-invite">
          <div><strong>Invite link (share with the member):</strong></div>
          <div>{inviteInfo.signupUrl}</div>
          <div style={{ marginTop: 6 }}><strong>Expires:</strong> {inviteInfo.expiresAt ? new Date(inviteInfo.expiresAt).toLocaleString() : '—'}</div>
        </div>
      )}

      {loading ? (
        <div className="sr-empty">Loading…</div>
      ) : requests.length === 0 ? (
        <div className="sr-empty">No pending requests (requests expire after 24 hours).</div>
      ) : (
        requests.map((r) => (
          <div key={r.id} className="sr-card">
            <div>
              <div><strong>Email:</strong> {r.requester_email}</div>
              <div className="sr-meta">Requested: {r.created_at ? new Date(r.created_at).toLocaleString() : '—'}</div>
            </div>

            <div className="sr-decision">
              <button
                className="approve"
                type="button"
                disabled={actingId === r.id}
                onClick={() => respond(r.id, 'approved')}
              >
                Approve
              </button>
              <button
                className="deny"
                type="button"
                disabled={actingId === r.id}
                onClick={() => respond(r.id, 'denied')}
              >
                Deny
              </button>
            </div>
          </div>
        ))
      )}
      </div>
    </div>
  );
}
